import { useSettingValueByCode } from '../../contexts/SettingsContext';
import { getAuthToken, getSelectedUserName, getUserEmail, getUserId, getUserName, resolveSlashcallPersonaApiKey, resolveSlashcallPersonaEmail, } from '../../services/auth-service';
import { PERSONAAS_MINIAPP_URL } from '../../utils/properties';
import { checkRoles, sanitizeVocCommandCenterApiKey } from '../../utils/util';
import './personaaSMiniApp.css';

function PersonaaSMiniApp({ disableAllPages = true }) {
    const identity = (getSelectedUserName() || getUserName() || '').trim();
    const hasSlashcallRole = checkRoles('ROLE_SLASHCALL');
    const currentEmail = (getUserEmail() || '').trim();
    const vocCommandCenter = sanitizeVocCommandCenterApiKey(useSettingValueByCode("VOC_COMMAND_CENTER"));
    const userEmail = resolveSlashcallPersonaEmail(hasSlashcallRole, currentEmail);
    const apiKey = resolveSlashcallPersonaApiKey(hasSlashcallRole, vocCommandCenter);

    const hasRequiredConfig = Boolean(apiKey);

    let iframeUrl = '';
    if (hasRequiredConfig && identity && userEmail) {
        const params = new URLSearchParams({
            apiKey: apiKey || '',
            userName: identity,
            userId: getUserId(),
            userEmail: userEmail,
            theme: JSON.stringify({
                primary: "#4A7CF5",         // Ozonetel blue
                primaryHover: "#3968E0",    // darker blue on hover
                primaryLight: "#EEF2FF",    // very light blue tint (backgrounds, pills)
                primaryLightHover: "#DBEAFE", // hover on light-blue elements
                primaryBorder: "#B8CCFA",   // blue-tinted border
                primaryDarkText: "#1E3A5F", // navy text on light-blue backgrounds
                headerBg: "#F6FAFD",
                headerText: "#1A1A2E",
                pageBg: "#F5F7FA",          // light cool-gray page background
                chatBg: "#F6FAFD",
                buttonText: "#FFFFFF",
                error: "#EF4444",
                borderRadius: "8px",
            }),
            additional_information: JSON.stringify({ data: { user_token: getAuthToken(), userId: getUserId() } })
        });
        iframeUrl = `${PERSONAAS_MINIAPP_URL}?${params.toString()}`;
    }

    const renderState = () => {

        if (!hasRequiredConfig) {
            return (
                <div className="personaasMiniAppState">
                    <div className="personaasMiniAppStateContent">
                        <h2 className="personaasMiniAppStateTitle">Command Center is not configured</h2>
                        <p className="personaasMiniAppStateText">
                            Set <code>REACT_APP_PERSONAAS_API_KEY</code> if you need to override the default Command Center API key.
                        </p>
                    </div>
                </div>
            );
        }

        if (!identity) {
            return (
                <div className="personaasMiniAppState">
                    <div className="personaasMiniAppStateContent">
                        <h2 className="personaasMiniAppStateTitle">Username unavailable</h2>
                        <p className="personaasMiniAppStateText">
                            The current VOC session does not expose a username value for the Command Center URL.
                        </p>
                    </div>
                </div>
            );
        }

        if (!userEmail) {
            return (
                <div className="personaasMiniAppState">
                    <div className="personaasMiniAppStateContent">
                        <h2 className="personaasMiniAppStateTitle">Email unavailable</h2>
                        <p className="personaasMiniAppStateText">
                            Command Center is waiting for the latest <code>getLoggedInUser</code> response to populate the stored email for this user.
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <iframe
                className="personaasMiniAppFrame"
                style={disableAllPages ? {} : { borderRadius: '14px' }}
                src={iframeUrl}
                title="Command Center"
                allow="clipboard-write"
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
            />
        );
    };

    return (
        <div className={disableAllPages ? "personaasMiniAppPage" : "personaasMiniAppPageEnabled"}>
            <section className="personaasMiniAppCard" style={disableAllPages ? {} : {
                border: '1px solid #e2e8f3',
                borderRadius: '16px',
                background: 'linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)',
                boxShadow: '0 14px 32px rgba(15, 23, 42, 0.08)',
            }}>
                <div className="personaasMiniAppBody">{renderState()}</div>
            </section>
        </div>
    );
}

export default PersonaaSMiniApp;
